/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cancel_Anytime_Billed_MonthlyInputs */

const en_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancel anytime. Billed monthly.`)
};

const es_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancela cuando quieras. Facturación mensual.`)
};

const fr_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulez à tout moment. Facturé mensuellement.`)
};

const de_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jederzeit kündbar. Monatliche Abrechnung.`)
};

const ja_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`いつでもキャンセル可能。月額請求。`)
};

const zh_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`随时可取消。按月计费。`)
};

const ar_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإلغاء متاح في أي وقت. تُدفع شهرياً.`)
};

const id_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Batal kapan saja. Ditagih secara bulanan.`)
};

const it_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Annulla in qualsiasi momento. Fatturazione mensile.`)
};

const ru_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Отмена в любое время. Ежемесячная оплата.`)
};

const pt_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cancele quando quiser. Cobrado mensalmente.`)
};

const ko_cancel_anytime_billed_monthly = /** @type {(inputs: Cancel_Anytime_Billed_MonthlyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`언제든지 취소 가능. 매월 청구됩니다.`)
};

/**
* | output |
* | --- |
* | "Cancel anytime. Billed monthly." |
*
* @param {Cancel_Anytime_Billed_MonthlyInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const cancel_anytime_billed_monthly = /** @type {((inputs?: Cancel_Anytime_Billed_MonthlyInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cancel_Anytime_Billed_MonthlyInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cancel_anytime_billed_monthly(inputs)
	if (locale === "es") return es_cancel_anytime_billed_monthly(inputs)
	if (locale === "fr") return fr_cancel_anytime_billed_monthly(inputs)
	if (locale === "de") return de_cancel_anytime_billed_monthly(inputs)
	if (locale === "ja") return ja_cancel_anytime_billed_monthly(inputs)
	if (locale === "zh") return zh_cancel_anytime_billed_monthly(inputs)
	if (locale === "ar") return ar_cancel_anytime_billed_monthly(inputs)
	if (locale === "id") return id_cancel_anytime_billed_monthly(inputs)
	if (locale === "it") return it_cancel_anytime_billed_monthly(inputs)
	if (locale === "ru") return ru_cancel_anytime_billed_monthly(inputs)
	if (locale === "pt") return pt_cancel_anytime_billed_monthly(inputs)
	return ko_cancel_anytime_billed_monthly(inputs)
});